import styled from 'styled-components';
import { breakpoints } from '../../../styles/theme';
import { PromoCodeStyled } from '../PromoCodeStyled';
import { rem } from 'polished';

export const PromoCodeStyledOV = styled(PromoCodeStyled)`
    background: #f2f2f2;

    .promoCode {
        &__title {
            color: ${({ theme }) => theme.colors.black};
            font-size: ${rem(16)};
            width: 100%;
            text-transform: none;

            @media (min-width: ${breakpoints.md}px) {
                width: 50%;
            }
        }

        &__input_label_success {
            width: 70%;
            left: 15%;
            background: ${({ theme }) => theme.colors.black3};
            color: ${({ theme }) => theme.colors.white};

            &::after {
                border-top: 7px solid ${({ theme }) => theme.colors.black2};
            }
        }

        &__input {
            width: 100%;
            border: 1px solid ${({ theme }) => theme.colors.grey16};
            color: ${({ theme }) => theme.colors.black2};

            &_error {
                border-color: ${({ theme }) => theme.colors.danger};
            }
        }

        &__button {
            text-transform: uppercase;
            width: 100%;
            border: 1px solid ${({ theme }) => theme.colors.black2};
            color: ${({ theme }) => theme.colors.black2};
            font-size: ${rem(14)};

            @media (min-width: ${breakpoints.md}px) {
                margin-left: ${rem(16)};
                width: 30%;
            }
        }
    }
`;
